import React, { useState } from 'react';
import { projects, categories } from '../data/companyData';
import './ProjectsPage.css';

export default function ProjectsPage() {
  const [filter, setFilter] = useState('All');
  const [view, setView] = useState('grid');

  const filtered = filter === 'All' ? projects : projects.filter(p => p.category === filter);
  const activeCount = projects.filter(p => p.status === 'active').length;
  const completedCount = projects.filter(p => p.status === 'completed').length;

  return (
    <main className="projects-page">

      <section className="page-header">
        <div className="container page-header__inner">
          <span className="tag">Our Portfolio</span>
          <h1 className="page-header__title">
            Completed Projects<br />
            <span style={{ color: 'var(--gold)' }}>One Standard of Excellence.</span>
          </h1>
          {/* Project stats removed as requested */}
        </div>
      </section>

      <section className="section">
        <div className="container">
          {/* Filters */}
          <div className="proj-filters">
            <div className="proj-filters__cats">
              {categories.map(cat => (
                <button
                  key={cat}
                  className={`proj-filter-btn ${filter === cat ? 'proj-filter-btn--active' : ''}`}
                  onClick={() => setFilter(cat)}
                >
                  {cat}
                </button>
              ))}
            </div>
            <div className="proj-filters__view">
              <button
                className={`view-btn ${view === 'grid' ? 'view-btn--active' : ''}`}
                onClick={() => setView('grid')}
                title="Grid view"
              >⊞</button>
              <button
                className={`view-btn ${view === 'list' ? 'view-btn--active' : ''}`}
                onClick={() => setView('list')}
                title="List view"
              >☰</button>
            </div>
          </div>

          {/* Count */}
          <div className="proj-count">
            Showing <strong>{filtered.length}</strong> project{filtered.length !== 1 ? 's' : ''}
            {filter !== 'All' && <> in <strong>{filter}</strong></>}
          </div>

          {/* Grid view */}
          {view === 'grid' && (
            <div className="proj-grid">
              {filtered.map(p => (
                <div key={p.id} className="proj-card">
                  <div className="proj-card__top">
                    <div className="proj-card__num">{String(p.id).padStart(2, '0')}</div>
                    <span className={`proj-card__badge proj-card__badge--${p.status}`}>
                      {p.status === 'active' ? '● Active' : '✓ Completed'}
                    </span>
                  </div>
                  <span className="proj-card__cat">{p.category}</span>
                  <h3 className="proj-card__title">{p.title}</h3>
                  <p className="proj-card__client">{p.client}</p>
                  <p className="proj-card__type">{p.type}</p>
                  <div className="proj-card__footer">
                    <div className="proj-card__duration">
                      <span className="proj-card__duration-label">Duration</span>
                      <span className="proj-card__duration-val">{p.duration}</span>
                    </div>
                    <div className="proj-card__period">{p.start} – {p.end}</div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* List view */}
          {view === 'list' && (
            <div className="proj-list">
              {filtered.map(p => (
                <div key={p.id} className="proj-list-item">
                  <div className="proj-list-item__num">{String(p.id).padStart(2, '0')}</div>
                  <div className="proj-list-item__info">
                    <h3 className="proj-list-item__title">{p.title}</h3>
                    <p className="proj-list-item__client">{p.client} · {p.type}</p>
                  </div>
                  <div className="proj-list-item__meta">
                    <span className="proj-card__cat">{p.category}</span>
                    <span>{p.duration}</span>
                    <span>{p.start} – {p.end}</span>
                    <span className={`proj-card__badge proj-card__badge--${p.status}`}>
                      {p.status === 'active' ? '● Active' : '✓ Done'}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* CTA */}
      <section className="section section--cream">
        <div className="container" style={{ textAlign: 'center' }}>
          <span className="tag">Work With Us</span>
          <h2 className="section-title" style={{ margin: '0 auto' }}>
            Let's Build Your<br />Next Success Story
          </h2>
          <p className="section-subtitle" style={{ margin: '16px auto 40px' }}>
            Whether it's a single building or an entire estate, PrimeFix delivers
            tailored maintenance solutions that protect your asset and your people.
          </p>
          <a href="/contact" className="btn btn-primary">Contact Our Team</a>
        </div>
      </section>

    </main>
  );
}
